import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

const PaddingElement = styled.div``;

// Tap-sized back affordance — at least 40px tall so it works comfortably
// on mobile (≥44px when you include hit-padding margin), with visible
// border + hover state.
const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  min-height: 40px;
  margin: 16px 0 20px;
  background: transparent;
  color: #479de6;
  border: 1px solid #479de6;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.1s ease, color 0.1s ease;

  &:hover,
  &:focus {
    background: #f3f8fd;
    color: #357ab8;
    outline: none;
    text-decoration: none;
  }
`;

const BackLinkFromYPX = ({ hidden = false, history }) => {
  if (hidden) {
    return (
      <PaddingElement className="backlink-from-product">&nbsp;</PaddingElement>
    );
  }

  return (
    <BackButton
      type="button"
      className="backlink-from-product"
      onClick={history.goBack}
      aria-label="Go back"
    >
      <span aria-hidden="true">←</span> Back
    </BackButton>
  );
};

export default withRouter(BackLinkFromYPX);
